export default "__VITE_ASSET__1d904273__"